import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-note-detail-header',
  templateUrl: './note-detail-header.component.html',
  styleUrl: './note-detail-header.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class.actions-beside-title]': 'actionsBesideTitle()' },
})
export class NoteDetailHeaderComponent {
  /** A personal note's actions sit beside its title; a team note keeps its own toolbar row above it (stitch-app-shell skin). */
  public readonly actionsBesideTitle = input(false);
}
